module.exports = __webpack_public_path__ + "img/desc.cae5d1c7.svg";